module.exports = __webpack_public_path__ + "img/how-works.e30b63dd.png";